import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class Veteran extends Component {
  onChange(item) {
    var veteranIndex = _.findIndex(
      this.props.filterState.filterData.veteran,
      (o) => {
        return o.veteran === item.veteran;
      }
    );
    item.checked = !this.props.filterState.filterData.veteran[veteranIndex]
      .checked;
    this.props.filterState.filterData.veteran[veteranIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item) {
    return (
      <li class="chechbox-list_item" key={"gliitem-" + item.veteran}>
        <span
          className="card-text custom-checkbox ml-3 mr-4"
          key={"gitem-" + item.veteran}
        >
          <input
            type="checkbox"
            htmlFor={"gitem-" + item.veteran}
            value={item.veteran}
            checked={item.checked}
            className="custom-control-input"
            id={"gitem-" + item.veteran}
            name={"gitem-" + item.veteran}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            style={{ color: this.props.isMobile ? "white" : null }}
            htmlFor={"gitem-" + item.veteran}
          >
            {item.veteran}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Veteran</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div class="filter-fields-scroll">
          <ul class="chechbox-list">
            {this.props.filterState.filterData.veteran &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.veteran.map((item) =>
                this.chechboxes(item)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(Veteran);
